// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___EM4q","trigger":"styles_trigger__Zd3nY"};